import React from "react";
import "./styles/graphicsSection.css";
import RunnerStats from "./RunnerStats";
import BadgeCard from "../../../../components/Dashboard/BadgeCard/BadgeCard";

const GraphicsSection = () => {
  return (
    <div className="graphs-container">
      <div className="main-graph p-2">
        <RunnerStats />
      </div>
      <div className="side-charts">
        <BadgeCard />
      </div>
    </div>
  );
};

export default GraphicsSection;
